import { styled } from '@linaria/react';
import { Stack, Timeline } from '@mantine/core';

import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import i18n from '../../../../../base-dictionary';
import { useRelatedTasksTabStore } from '../../../../../store/strategy-store/strategy-store';
import { skyDark } from '../../../../../styles/design-tokens';
import { Icon } from '../../../../../ui-library/icon/icon';
import { Text } from '../../../../../ui-library/typography/typography';

dayjs.extend(advancedFormat);
dayjs.extend(utc);
dayjs.extend(timezone);

export const SideSectionTaskLog = () => {
  const transitions = useRelatedTasksTabStore((state) => state.selectedTask?.transitions || []);

  if (transitions.length === 0) {
    return null;
  }

  const reversedTransitions = transitions.toReversed();

  return (
    <Stack gap="md">
      <Text weight="medium" size="small">
        {i18n.t('strategy.initiative_performance.task_log')}:
      </Text>
      <StyledTimeline lineWidth={1}>
        {reversedTransitions.map((transition, index) => (
          <TaskLogItem
            key={`${transition.status}-${index}`}
            {...transition}
            start={index === reversedTransitions.length - 1}
          />
        ))}
      </StyledTimeline>
    </Stack>
  );
};

const TaskLogItem = ({
  status,
  changed_by,
  changed_at,
  start,
}: {
  status: string;
  changed_by: string;
  changed_at: string;
  start: boolean;
}) => {
  const iconName = start ? 'fiber_manual_record' : 'arrow_forward_ios';
  const disableChangeBy = !changed_by || changed_by.toLowerCase() === 'unknown';

  return (
    <Timeline.Item
      bullet={<Icon name={iconName} size={12} style={{ transform: 'rotate(-90deg)' }} variant="filled" />}
      lineVariant="solid"
      pb={start ? 0 : 24}
    >
      <Text size="tiny" lineHeight="none">
        {i18n.t('strategy.initiative_performance.status_changed_to')} '<StatusText>{status}</StatusText>'
      </Text>
      <Text size="tiny" color={skyDark} lineHeight="tight">
        {dayjs(changed_at).format('dddd, MMM D [at] h:mm a z')}
      </Text>
      {!disableChangeBy && (
        <Text size="tiny" color={skyDark} lineHeight="tight">
          {i18n.t('strategy.initiative_performance.changed_by', { user: changed_by })}
        </Text>
      )}
    </Timeline.Item>
  );
};

const StatusText = styled.span`
  font-weight: bold;
  font-family: inherit;
  font-size: inherit;
`;

const StyledTimeline = styled(Timeline)`
  .mantine-Timeline-itemBullet {
    background-color: transparent;
    border: none;
  }

  .mantine-Timeline-item {
    border-left: 1px solid var(--sky-light);
    margin-top: 0;

    &::before {
      display: none;
    }
  }
`;
